mutation PublishGiveawayWinners($giveawayId: ID!) {
  giveaway: StreamToolsPublishGiveawayWinners(giveawayId: $giveawayId) {
    giveawayId
    status
    entrantCount
    hasDraw
    startedAt
    closedAt
    publishedAt
    version
    winners {
      login
      displayName
      rank
      kind
    }
  }
}
